export * from './area/area.component';
export * from './xqhjth.component';
